// Local capture can resume a previously authenticated, unexpired session on a
// transport failure. The server still validates the JWT on every submission.
export const canResumeOfflineSession = (token, user, error) => {
  if (error?.response || !user?.id || !token) return false;
  if (navigator.onLine !== false && !['ERR_NETWORK', 'ECONNABORTED', 'ETIMEDOUT'].includes(error?.code)) return false;
  try {
    const body = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(body));
    return String(payload.id) === String(user.id) && Number.isFinite(payload.exp) && payload.exp * 1000 > Date.now();
  } catch (_) { return false; }
};
